import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The min-rep letter families' gates (docs/plans/2026-10-29-feat-minrep-flowing-letter-editor-plan.md,
 * U3), spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts at their place in its order. Each
 * is a compatibility gate, not a sidebar item.
 */
export const MINREP_FEATURE_GATE_SEEDS = {
  minrep_tables: {
    label: 'Letter tables',
    shortLabel: 'Letter tables',
    description:
      'Lets staff add tables to ministerial representation letters. Not a sidebar item - off means a letter without a table cannot gain one; letters that already hold a table keep editing it, and every table still prints in the letter PDF.',
    group: 'correspondence',
  },
  minrep_flowing_letters: {
    label: 'Flexible letter layout',
    shortLabel: 'Flexible letters',
    description:
      'New ministerial representation letters start in the flexible layout, and staff can switch an existing letter to it. There the date, recipient, salutation, closing and signature are parts of the letter they can move, edit or delete. Not a sidebar item - off means new letters start in the fixed layout and no letter can be switched; flexible letters keep editing and printing as they are.',
    group: 'correspondence',
  },
  minrep_pilot_fixes: {
    label: 'Letter details for pilot offices',
    shortLabel: 'Letter details',
    description:
      'Ministerial representation letters gain the person they are written on behalf of and a contact sentence, "Via email" in place of the postal address for email delivery, recipients for one letter only, and their own rows in Approvals. Not a sidebar item - off hides these controls and keeps Approvals as it is; letters keep printing what they already store.',
    group: 'correspondence',
  },
} satisfies Record<string, FeatureGateSeed>;
